import { render, staticRenderFns } from "./EnrollmentScreens.vue?vue&type=template&id=4fc6fbcd&scoped=true&"
import script from "./EnrollmentScreens.vue?vue&type=script&lang=js&"
export * from "./EnrollmentScreens.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentScreens.vue?vue&type=style&index=0&id=4fc6fbcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc6fbcd",
  null
  
)

export default component.exports